
import AxiosClient from "../../../services/axios.services";

class TrainingEvents {
  getTrainingEvents = params =>
    AxiosClient.get("api/app/capacitacion_evento_capacitacion/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });
  getTrainingEventsById = (id) =>
    AxiosClient.get(`api/app/capacitacion_evento_capacitacion/${id}`, {
      headers: { "Content-Type": "application/json" },
    });
  getEmployeesResponsible = (params) =>
    AxiosClient.get("api/app/busqueda_personas_por_rol/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });
  saveTrainingEvents = data =>
    AxiosClient.post("api/app/capacitacion_evento_capacitacion/", data, {
      headers: { "Content-Type": "application/json" },
    });
  editTrainingEvents = (id, data) =>
    AxiosClient.put(`api/app/capacitacion_evento_capacitacion/${id}/`, data, {
      headers: { "Content-Type": "application/json" },
    });
  editTrainingEventsCompanies = (id, data) =>
    AxiosClient.put(`api/app/capacitacion_empresas_evento/${id}/`, data, {
      headers: { "Content-Type": "application/json" },
    });
  deleteTrainingEvents = id =>
    AxiosClient.delete(`api/app/capacitacion_evento_capacitacion/${id}`, {
      headers: { "Content-Type": "application/json" },
    });
  getTrainingFile = (id) =>
    AxiosClient.get(`/api/app/capacitacion_archivo_evaluacionViewset/${id}/`, {
      headers: { "responseType": "blob" },
    });
}

export default new TrainingEvents();